<template>
    <b-modal
        v-if="item.exclusao"
        :hide-footer="true"
        :no-close-on-backdrop="true"
        :title="$t('Motivo da exclusão')"
        centered
        size="lg"
        @hidden="cancelar"
        id="modal-usuario-excluida"
    >
        <load mode="table" v-if="loading" />
        <div v-show="!loading" class="row px-3">
            <h2 v-if="item.exclusao.familia_excluida == 1" class="col-12 px-0">
                {{
                    getTitleArray(
                        parseInt(item.exclusao.motivo_exc_mbo),
                        motivos_familia
                    )
                }}
            </h2>
            <h2 v-else class="col-12 px-0">
                {{
                    getTitleArray(
                        parseInt(item.exclusao.motivo_exc_mbo),
                        motivos
                    )
                }}
            </h2>
            <h4 class="col-12 px-0" v-if="item.exclusao.desc_mot_exc">
                Descrição
            </h4>
            <p v-html="item.exclusao.desc_mot_exc"></p>
            <br />
            <h4
                class="col-12 px-0"
                v-if="parseInt(item.exclusao.motivo_exc_mbo) == 1"
            >
                Certidões de óbitos
            </h4>
            <div v-if="parseInt(item.exclusao.motivo_exc_mbo) == 1">
                <table
                    class="b-table table table-bordered bg-white b-table-stacked-md"
                >
                    <!-- <thead>
                        <tr>
                            <td
                                :colspan="
                                    item.exclusao.certidao_obitos.falecimento ==
                                    'a'
                                        ? 7
                                        : 6
                                "
                                v-html="obito.value"
                            ></td>
                        </tr>
                    </thead> -->
                    <tbody>
                        <tr v-if="item.exclusao.nom_cartorio_certid_mbo_exc">
                            <td>
                                Cartório:
                                <b>{{
                                    item.exclusao.nom_cartorio_certid_mbo_exc
                                }}</b>
                            </td>
                            <td>
                                Livro:
                                <b>{{
                                    item.exclusao.cod_livro_termo_certid_mbo_exc
                                }}</b>
                            </td>
                            <td>
                                Folha:
                                <b>{{
                                    item.exclusao.cod_folha_termo_certid_mbo_exc
                                }}</b>
                            </td>
                            <td>
                                Número termo:
                                <b>{{
                                    item.exclusao
                                        .cod_termo_matricula_certid_mbo_exc
                                }}</b>
                            </td>
                            <td>
                                UF:
                                <b>{{ item.exclusao.sig_uf_certid_mbo_exc }}</b>
                            </td>
                            <td>
                                Município:
                                <b
                                    v-if="
                                        item.exclusao.nom_munic_certid_mbo_exc
                                    "
                                    >{{
                                        item.exclusao.nom_munic_certid_mbo_exc
                                    }}</b
                                >
                                <b v-else>{{
                                    getTitleArray(
                                        item.exclusao
                                            .cod_ibge_munic_certid_mbo_exc,
                                        municipios
                                    )
                                }}</b>
                            </td>
                            <td>
                                Data emissão:
                                <b>{{
                                    item.exclusao.dta_emissao_certid_mbo_exc
                                        | formatDate
                                }}</b>
                            </td>
                        </tr>
                        <tr v-if="item.exclusao.nom_servd_pbco_pgmcu_mbo">
                            <td>
                                Nome Servidor:
                                <b>{{
                                    item.exclusao.nom_servd_pbco_pgmcu_mbo
                                }}</b>
                            </td>
                            <td>
                                CPF servidor:
                                <b>{{
                                    item.exclusao.cpf_servd_pbco_pgmcu_pgmcu_mbo
                                }}</b>
                            </td>
                            <td>
                                Número:
                                <b>{{ item.exclusao.num_pgmcu_mbo }}</b>
                            </td>
                            <td>
                                UF:
                                <b>{{ item.exclusao.uf_pgmcu_mbo }}</b>
                            </td>
                            <td>
                                Município:
                                <b>{{
                                    getTitleArray(
                                        item.exclusao.mun_pgmcu_mbo,
                                        municipios
                                    )
                                }}</b>
                            </td>
                            <td>
                                Data emissão:
                                <b>{{
                                    item.exclusao.dat_emi_pgmcu_mbo | formatDate
                                }}</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div
                v-if="
                    item.exclusao.familia_excluida == 1 &&
                        (parseInt(item.exclusao.motivo_exc_mbo) == 2 ||
                            parseInt(item.exclusao.motivo_exc_mbo) == 3 ||
                            parseInt(item.exclusao.motivo_exc_mbo) == 8)
                "
            >
                <table
                    class="b-table table table-bordered bg-white b-table-stacked-md"
                >
                    <tbody>
                        <tr>
                            <td>
                                Nome Servidor:
                                <b>{{
                                    item.exclusao.nom_servd_pbco_pgmcu_mbo
                                }}</b>
                            </td>
                            <td>
                                CPF servidor:
                                <b>{{
                                    item.exclusao.cpf_servd_pbco_pgmcu_pgmcu_mbo
                                }}</b>
                            </td>
                            <td>
                                NÚmero:
                                <b>{{ item.exclusao.num_pgmcu_mbo }}</b>
                            </td>
                            <td>
                                UF:
                                <b>{{ item.exclusao.uf_pgmcu_mbo }}</b>
                            </td>
                            <td>
                                Município:
                                <b>{{
                                    getTitleArray(
                                        item.exclusao.mun_pgmcu_mbo,
                                        municipios
                                    )
                                }}</b>
                            </td>
                            <td>
                                Data emissão:
                                <b>{{
                                    getData(item.exclusao.dat_emi_pgmcu_mbo)
                                }}</b>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return {
            motivos: [
                { id: 1, value: "Falecimento da pessoa" },
                { id: 2, value: "Desligamento da pessoa daquela família" },
                { id: 3, value: "Solicitação da pessoa" },
                { id: 4, value: "Decisão judicial" },
                { id: 5, value: "Averiguação - Suspeita de Fraude" }
            ],
            motivos_familia: [
                { id: 1, value: "Falecimento de toda familia" },
                { id: 2, value: "Recusa da família em prestar informações" },
                {
                    id: 3,
                    value:
                        "Comprovação de omissão de informações ou prestação de informação inverídicas pela familia"
                },
                { id: 4, value: "Solicitação da familia" },
                { id: 5, value: "Decisão judicial" },
                {
                    id: 6,
                    value: "Familia não localizada para atualização/revalidação"
                },
                {
                    id: 7,
                    value:
                        "Familia com renda per capita acima de 1/2(meio) salário mínimo e renda familiar acima de 3 salários mínimos e que não esteja vinculada a nenhum programa social"
                },
                { id: 8, value: "Averiguação - Suspeita de Fraude" }
            ],
            falecimento: "",
            tipos_falecimento: [
                { id: "a", value: "Certidão de Óbito" },
                {
                    id: "b",
                    value: "Parecer da gestão municipal do cadastro único"
                }
            ],
            municipios: [],
            loading: true
        };
    },
    watch: {
        item() {
            if (this.item.exclusao) {
                this.getMunicipios([
                    this.item.exclusao.cod_ibge_munic_certid_mbo_exc,
                    this.item.exclusao.mun_pgmcu_mbo
                ]);
            }
        }
    },
    methods: {
        getTitleArray(valor, array) {
            const result = array.filter(item => item.id == valor);
            return result[0] ? result[0].value : "";
        },
        getMunicipios(cidades) {
            if (cidades) {
                this.loading = true;
                axios
                    .post("api/dashboard/enderecos/get/cidades", {
                        cidades: cidades
                    })
                    .then(response => {
                        this.municipios = response.data;
                        this.loading = false;
                    });
            }
        },
        getData(data) {
            if (data) {
                return data.replaceAll("-", "/");
            }
        },
        cancelar() {
            Object.assign(this.$data, this.$options.data.call(this));
            this.$emit("cancelado");
            this.$bvModal.hide("modal-usuario-excluida");
        }
    }
};
</script>
